function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import SubHeaderLogo from './SubHeaderLogo.react';
var SubHeaderMaterials = function SubHeaderMaterials(_ref) {
  var app = _ref.app,
    navArr = _ref.navArr,
    route = _ref.route,
    setSelected = _ref.setSelected;
  var navigate = useNavigate();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    activeArr = _useState2[0],
    setActiveArr = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "nav-header"
  }, /*#__PURE__*/React.createElement(SubHeaderLogo, {
    app: app
  })), /*#__PURE__*/React.createElement("div", {
    className: "nav-header__child1"
  }, /*#__PURE__*/React.createElement("ul", null, navArr.filter(function (x) {
    return !x.parentID;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("li", {
      onClick: function onClick() {
        setSelected(x);
        if (x.children) setActiveArr([x]);else setActiveArr([]);
        navigate("/".concat(app, "/").concat(route, "/").concat(x._id));
      },
      key: x._id
    }, x.title);
  }))), activeArr === null || activeArr === void 0 ? void 0 : activeArr.map(function (x, i) {
    var count = i + 1;
    return /*#__PURE__*/React.createElement("div", {
      className: "nav-header__child1",
      key: count
    }, /*#__PURE__*/React.createElement("ul", null, navArr.filter(function (x) {
      return x.parentID === activeArr[i]._id;
    }).sort(function (a, b) {
      return a.slot - b.slot;
    }).map(function (x) {
      return /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          setSelected(x._id);
          if (x.children) setActiveArr([].concat(_toConsumableArray(activeArr.slice(0, count)), [x]));else setActiveArr(activeArr.slice(0, count));
          navigate("/".concat(app, "/").concat(route, "/").concat(x._id));
        },
        key: x._id
      }, x.title);
    })));
  }));
};
export default SubHeaderMaterials;